<template>
  <v-container fluid pt-0>
    <v-card flat color="background">
      <v-card-title>Printers</v-card-title>
      <v-card-subtitle>Configure location printers</v-card-subtitle>
      <v-card-text></v-card-text>
      <v-data-table class="background" :headers="headers" :items="printers" hide-default-footer>
        <template v-slot:item.actions="{ item }">
          <v-btn @click="editPrinter(item)" class="my-2" elevation="0" small fab color="primary">
            <v-icon small>edit</v-icon>
          </v-btn>
          <v-btn
            @click="deletePrinter(item)"
            class="my-2 ml-2"
            elevation="0"
            small
            fab
            color="primary"
          >
            <v-icon small>delete</v-icon>
          </v-btn>
        </template>
        <template v-slot:item.is_active="{ item }">
          <v-switch v-model="item.is_active" inset></v-switch>
        </template>
      </v-data-table>
    </v-card>
    <v-dialog
      v-model="dialog"
      scrollable
      persistent
      max-width="700px"
      transition="dialog-transition"
    >
      <v-card>
        <v-card-title v-if="!editingPrinter">Add a printer</v-card-title>
        <v-card-title v-else>Editing Printer</v-card-title>
        <v-card-subtitle v-if="!editingPrinter">Add a new printer to your location</v-card-subtitle>
        <v-card-subtitle v-else>Update current selected printer</v-card-subtitle>
        <v-card-text>
          <v-text-field v-model="newPrinter.name" persistent-hint hint="Printer name" label="Name"></v-text-field>
          <v-text-field
            v-model="newPrinter.serial_no"
            persistent-hint
            hint="The Serial No associated to your printer. This can usually be found at the bottom of your UNOapp printer."
            label="Serial No"
          ></v-text-field>
          <v-text-field
            v-model="newPrinter.key"
            persistent-hint
            hint="This is the Key associated to your printer. This can usually be found at the bottom of your UNOapp printer."
            label="Key"
          ></v-text-field>
          <v-text-field
            v-model.number="newPrinter.copies"
            persistent-hint
            hint="The number of copies that you would like printed for each order."
            label="Copies"
          ></v-text-field>
          <v-text-field
            v-model.number="newPrinter.version"
            persistent-hint
            hint="The 'version' number for your printer. You should only change this if you have been given a different version to use."
            label="Version"
          ></v-text-field>
          <v-text-field
            v-model.number="newPrinter.paper_width"
            persistent-hint
            hint="The width of the paper roll that your printer will be using. This is usually 58mm or 80mm."
            label="Paper Width"
          ></v-text-field>
          <v-switch
            v-model="newPrinter.is_active"
            label="Active"
            hint="Enable this printer for your location and allow it to receive orders."
            persistent-hint
            inset
          ></v-switch>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            text
            color="grey"
            @click="dialog=false; resetNewPrinter()"
            class="text-capitalize"
          >Cancel</v-btn>
          <v-btn @click="handleConfirm" color="primary" class="text-capitalize">Confirm</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-tooltip left>
      <template v-slot:activator="{ on }">
        <v-btn @click="dialog = true" fab fixed dark bottom right color="primary" v-on="on">
          <v-icon>add</v-icon>
        </v-btn>
      </template>
      <span>Add Printers</span>
    </v-tooltip>
  </v-container>
</template>

<script>
import { LocationAPI } from '@/clients/locations/locations.api'
export default {
  mounted() {
    this.$root.$on('item-deleted', async (s) => {
      await this.getLocationPrinters()
      this.swal({ title: 'Success', text: 'Printer deleted successfully.', timer: 3000 })
      this.dialog = false
      this.resetNewPrinter()
    })
    this.getLocationPrinters()
  },
  data() {
    return {
      dialog: false,
      editingPrinter: false,
      printers: [],
      newPrinter: {
        'id': '',
        'location_id': '',
        'name': '',
        'serial_no': '',
        'key': '',
        'copies': 1,
        'version': 1,
        'paper_width': 80,
        'is_active': true
      },
      headers: [
        {
          text: 'Name',
          value: 'name',
          sortable: true,
          align: ''
        },
        {
          text: 'Serial No',
          value: 'serial_no',
          sortable: false,
          align: ''
        },
        {
          text: 'Key',
          value: 'key',
          sortable: false
        },
        {
          text: 'Copies',
          value: 'copies',
          sortable: false
        },
        {
          text: 'Version',
          value: 'version',
          sortable: false
        },
        {
          text: 'Paper Width',
          value: 'paper_width',
          sortable: false
        },
        {
          text: 'Active',
          value: 'is_active',
          sortable: false
        },
        {
          text: 'Actions',
          value: 'actions',
          sortable: false
        }
      ]
    }
  },
  methods: {
    async getLocationPrinters() {
      let res
      try {
        res = await LocationAPI.getLocationPrinters(this.$route.params['id'])
      } catch (error) {
        if (error.response.status === 404) {
          this.printers = []
        }
        return console.log(error.response.status)
      }
      this.printers = res.data.payload
    },
    async addAPrinter() {
      let data = this.newPrinter
      data.location_id = this.$route.params['id']
      let res
      try {
        res = await LocationAPI.addPrinterToLocation(data)
      } catch (error) {
        return console.log(error)
      }
      this.dialog = false
      this.printers.push(res.data.payload)
      this.resetNewPrinter()
      this.swal({ title: 'Success', text: 'Printer added successfully.', timer: 3000 })
    },
    async updatePrinter() {
      let data = this.newPrinter
      try {
        await LocationAPI.updatePrinter(data.id, data)
      } catch (error) {
        return console.log(error)
      }
      await this.getLocationPrinters()
      this.dialog = false
      this.resetNewPrinter()
      this.swal({ title: 'Success', text: 'Printer updated successfully.', timer: 3000 })
    },
    async deletePrinter(printer) {
      this.openDeleteModal({ title: 'Are you sure you want to delete the printer?',
        callback: () => LocationAPI.deletePrinterFromLocation(printer.id) })
    },
    handleConfirm() {
      if (this.editingPrinter) {
        this.updatePrinter()
      } else {
        this.addAPrinter()
      }
    },
    editPrinter(printer) {
      this.newPrinter = JSON.parse(JSON.stringify(printer))
      this.editingPrinter = true
      // Object.keys(this.editingPrinter).forEach(key => { this.editingPrinter[key] = printer[key] })
      this.dialog = true
    },
    resetNewPrinter() {
      this.editingPrinter = false
      this.newPrinter = {
        'id': '',
        'location_id': '',
        'name': '',
        'serial_no': '',
        'key': '',
        'copies': 1,
        'version': 1,
        'paper_width': 80,
        'is_active': true
      }
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
